import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import Select from 'react-select';


const Renewals = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState(''); // 'Paid' or 'Pending'
    const [customers, setCustomers] = useState([
        {
            name: 'John Doe',
            joiningDate: '2023-05-01',
            expiryDate: '2024-05-01',
            amount: '₹5000',
            mobileNumber: '9876543210',
            status: 'Paid',
            receipt: 'receipt1.pdf',
        },
        {
            name: 'Jane Smith',
            joiningDate: '2023-06-15',
            expiryDate: '2024-06-15',
            amount: '₹3000',
            mobileNumber: '9876543211',
            status: 'Pending',
            receipt: 'receipt2.pdf',
        },
    ]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const filtered = customers.filter((customer) =>
            (statusFilter ? customer.status === statusFilter : true) && // Apply status filter
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search or filter
    }, [searchQuery, customers, statusFilter]);


    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const handleStatusChange = (selectedOption) => {
        // If the selectedOption is null (cleared selection), set it to an empty string
        setStatusFilter(selectedOption ? selectedOption.value : '');
    };
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = (indexToDelete) => {
        const updatedCustomers = customers.filter((_, index) => index !== indexToDelete);
        setCustomers(updatedCustomers);
    };

    const statusOptions = [
        { value: '', label: 'All Statuses' },
        { value: 'Paid', label: 'Paid' },
        { value: 'Pending', label: 'Pending' },
    ];


    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Renewals</h1>
            </div>

            <div className="filter-search-select">
                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Status Filter using React Select */}
                <div className="status-filter">
                    <Select
                        value={statusFilter ? { value: statusFilter, label: statusFilter } : null}
                        onChange={handleStatusChange}
                        options={statusOptions}
                        placeholder="Select Status"
                        isClearable
                    />
                </div>
            </div>

            {/* Customer Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Joining Date</th>
                            <th>Expiry Date</th>
                            <th>Amount</th>
                            <th>Mobile Number</th>
                            <th>Status</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.name}</td>
                                    <td>{customer.joiningDate}</td>
                                    <td>{customer.expiryDate}</td>
                                    <td>{customer.amount}</td>
                                    <td>{customer.mobileNumber}</td>
                                    <td>{customer.status}</td>
                                    <td>
                                        <a href={`/${customer.receipt}`} target="_blank" rel="noopener noreferrer">
                                            Download
                                        </a>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center' }}>No data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </>
    );
};

export default Renewals;
